module.exports = __webpack_public_path__ + "img/plus-grey.1bfffe26.svg";